"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerBrowserConfiguration = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _loggerConfigurationSchema = require("../loggerConfigurationSchema");
const LOCAL_STORAGE_KEY = 'ori-logger-configuration';
const LoggerBrowserConfiguration = exports.LoggerBrowserConfiguration = {
  get() {
    const localStorageValue = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!localStorageValue) {
      return null;
    }
    try {
      const parsed = _loggerConfigurationSchema.loggerConfigurationSchema.partial().safeParse(JSON.parse(localStorageValue));
      return parsed.data ?? null;
    } catch {
      return null;
    }
  },
  set(input) {
    const validated = _loggerConfigurationSchema.loggerConfigurationSchema.parse(input);
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(validated));
  },
  update(input) {
    const validated = _loggerConfigurationSchema.loggerConfigurationSchema.partial().parse(input);
    const current = this.get();
    const mergedWithCurrent = current ? (0, _deepmerge.default)(current, validated) : validated;
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(mergedWithCurrent));
  }
};
//# sourceMappingURL=LoggerBrowserConfiguration.js.map